import * as Yup from 'yup'

export const VerifyMfaSchema = Yup.object({
  mfaCode: Yup.string().min(6).max(6).required('Mfa code is required'),
})

export type VerifyMfaValues = Yup.InferType<typeof VerifyMfaSchema>
